<template>
    <p class="u-mar-b9">
        <span v-for="(options, index) in items">
            <BaseChip :iconSelected="iconSelected"
                :iconPosition="iconPosition"
                :isSelected="options.Selected"
                :value="options.Value" 
                @click=""
            />
        </span>
    </p>
</template>

<script>
export default {
    props: {
        iconPosition: {
            type: String,
            default: 'left'
        },
        iconSelected: {
            type: String,
            default: 'left'
        },
        items: {
            type: Object,
            required: true
        },
	    },
    data () {
        return {
            options: this.items,
        };
	    },
    methods: {}
};
</script>